var map = {
	"./banner_comp.png": 4563,
	"./banner_comp_mobile.png": 2294,
	"./caroff.png": 1378,
	"./caron.png": 1390,
	"./cow.png": 2358,
	"./frogs.png": 2918,
	"./phoneoff.png": 2824,
	"./phoneon.png": 3452,
	"./plane.png": 7845,
	"./popup-error-image.png": 3680,
	"./rooster.png": 7243,
	"./seaoff.png": 6327,
	"./seaon.png": 1677,
	"./start_kidjo.png": 2783,
	"./subscription-modal.png": 3260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;